import React from "react";
import Button from "../../atoms/Button";

import "./button-group.m.css";

const ButtonGroup = ({ buttons, ...props }) => {
  return (
    <div styleName="button-group" {...props}>
      {buttons?.map((button, index) => {
        const { variant, href, onClick, label } = button || {};
        return (
          <Button
            key={index}
            variant={variant}
            href={href}
            onClick={onClick}
            eventsPage={true}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};

export default ButtonGroup;